import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom'
 
import * as analytics from '../utils/ga4';
 
export function useAnalytics() {
  const location = useLocation()
  const { user, isAuthenticated, fetchAuthFinish } = useSelector(state => state.auth);
  const [initGaUser, setInitGaUser] = useState();
 
  useEffect(() => {
    if (fetchAuthFinish) {
      analytics.init();
      console.log("init ga");
    }
  }, [fetchAuthFinish])
 
  useEffect(() => {
    if (isAuthenticated === true) {
      analytics.setUser({
        exidentifier: user.exidentifier,
        student_kita: user.studentkita || "-",
        student_makbila: user.studentmakbila || "-",
        student_mosad: user.studentmosad || "-",
        isstudent: user.isstudent
      })
      console.log("setInitGaUser");
      setInitGaUser(true)
    }
    else if (isAuthenticated === false) {
      analytics.setUser({
        exidentifier: "-",
        student_kita: "-",
        student_makbila: "-",
        student_mosad: "-",
        isstudent: "-"
      })
      console.log("setInitGaUser");
      setInitGaUser(true)
    }
  }, [user, isAuthenticated])
 
  useEffect(() => {
    console.log("location change ");
    if (initGaUser) {
      console.log("location change to ga");
      const path = location.pathname + location.search
      analytics.sendPageview(path)
    }
  }, [location, initGaUser])
}
 
export default useAnalytics